import './styles.css';
import { createRoot } from 'react-dom/client';
import { LandingPage } from './landing.js';
import { rememberVisit } from './acquisition.js';

// Keep the visit's ?ref= / ?code= for the sign-up form on /start or /pricing (ADR-0152).
rememberVisit();
createRoot(document.getElementById('root')!).render(<LandingPage />);
